import React from 'react';
import { Col, Row, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const TableCard = ({ table, isOpen, toggleTableState, redirect, taskCount }) => {
  return (
    <Col key={'table_' + table.table_id} xs={12} md={6} lg={4}>
      <Card border="light" className="mb-2">
          <Card.Header 
            className={`d-flex justify-content-between align-items-center ${!isOpen ? "round" : ""}`}
            onClick={() => toggleTableState(table.table_id)}
          >
              {/* Bal oldalon ikon és név */}
              <div className="d-flex align-items-center">
                <FontAwesomeIcon className="icon brown" icon={'location-dot'} />
                <strong className="ms-2">{table.name}</strong>
                {<span className="table-name-counter brown-bg">{taskCount}</span>}
              </div>
              
              {/* Jobb oldalon gomb */}
              <div className="d-flex align-items-center">
                  {redirect && (
                    <span className="btn button btn-flt-r" onClick={(e) => redirect(e, `/task/${table.table_id}`)}>
                      <FontAwesomeIcon icon="fa-solid fa-arrow-right" />
                    </span>
                  )}
              </div>
          </Card.Header>

        {isOpen && (
          <Card.Body>
            <Row>
              <Col><span>Terület</span></Col>
              <Col><span>{table.area}</span></Col>
            </Row>
            <Row>
              <Col><span>Táblák száma</span></Col>
              <Col><span>{table.parcel_count}</span></Col>
            </Row>
          </Card.Body>
        )}
      </Card>
    </Col>
  );
};

export default TableCard;
